import { parseSync } from '@bingads-webui/safe-json';
import { QuestionConfiguration, SurveyConfiguration } from './survey.types';
import {
  SingleSelectionConfigurator,
  MultipleSelectionConfigurator,
  EmailConfigurator,
  CommentConfigurator,
  RatingConfigurator,
} from './survey-construction';
import { JsonQuestion } from './json-survey.types';

const questionTypes = {
  Rating: 'Rating',
  Email: 'Email',
  SingleSelection: 'SingleSelection',
  MultipleSelection: 'MultipleSelection',
  Comment: 'Comment',
};

function jsonConfigurationToQuestionConfiguration(jsonConfiguration: JsonQuestion) {
  const {
    key,
    options,
    isRequired,
    page,
    data,
    position,
    title,
    isVisible,
    maxLength,
    placeholder,
    description,
    linkText,
    href,
  } = jsonConfiguration;

  // @ts-ignore
  const questionConfiguration: QuestionConfiguration = {
    key,
    options,
    isRequired,
    page,
    position,
    data,
    getTitle: () => title,
    isVisible: () => isVisible,
    getDescription: description ? () => description : undefined,
    maxLength,
    linkText,
    href,
    placeholder,
  };

  switch (jsonConfiguration.Type) {
    case questionTypes.Rating:
      questionConfiguration.Type = RatingConfigurator;
      break;
    case questionTypes.Email:
      questionConfiguration.Type = EmailConfigurator;
      break;
    case questionTypes.SingleSelection:
      questionConfiguration.Type = SingleSelectionConfigurator;
      break;
    case questionTypes.MultipleSelection:
      questionConfiguration.Type = MultipleSelectionConfigurator;
      break;
    case questionTypes.Comment:
      questionConfiguration.Type = CommentConfigurator;
      break;
    default:
      throw new Error('Out of control!');
  }

  return questionConfiguration;
}

export function jsonConfigurationToSurveyConfiguration(jsonConfiguration: string):
  (options: { i18n: any, serverContext: any }) => SurveyConfiguration {
  const parsedJsonConfiguration = parseSync(jsonConfiguration);
  return () => {
    const {
      style,
      others,
      featureArea,
    } = parsedJsonConfiguration;

    const surveyConfiguration: SurveyConfiguration = {
      featureArea,
      style,
      others,
    };

    // @ts-ignore
    surveyConfiguration.rating = jsonConfigurationToQuestionConfiguration(parsedJsonConfiguration.rating);
    // @ts-ignore
    surveyConfiguration.email = jsonConfigurationToQuestionConfiguration(parsedJsonConfiguration.email);
    surveyConfiguration.questions = parsedJsonConfiguration.questions.map(jsonConfigurationToQuestionConfiguration);

    return surveyConfiguration;
  };
}

function hashFunc(str) {
  let hash = 0;
  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i += 1) {
    const char = str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = ((hash << 5) - hash) + char;
    // eslint-disable-next-line no-bitwise
    hash &= hash;
  }
  return hash;
}

export function generateLabelId(str) {
  const hashValue = hashFunc(str).toString();
  const labelId = `survey-factory-label-${str}-${hashValue}`;
  return labelId;
}

export const returnFocus = (element) => {
  if (element) {
    element.focus();
    return;
  }
  /* istanbul ignore next */
  const body = document.getElementsByTagName('body')[0];
  /* istanbul ignore if */
  if (body) {
    body.focus();
  }
};
